import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServerLoggerService } from '~shared/modules/server-logger/services/server-logger.service';
import { ServerLoggerConfigToken } from '~shared/modules/server-logger/tokens/server-logger.token';
import { ServerLoggerConfig } from '~shared/modules/server-logger/models/server-logger-config.interface';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: []
})
export class ServerLoggerModule {
  public static forRoot(configFactory: () => ServerLoggerConfig): ModuleWithProviders<ServerLoggerModule> {
    return {
      ngModule: ServerLoggerModule,
      providers: [
        ServerLoggerService,
        {
          provide: ServerLoggerConfigToken,
          useFactory: configFactory,
        },
      ],
    };
  }
}
